<template>
  <span :class="['selected-value', {upcase: upcase}]">
    {{ label }}
    <button v-if="showRemoveItem" type="button" class="remove text-reset" @click="removeItem"><i class="icon-cancel" /></button>
  </span>
</template>


<script>
export default {
  props: {
    label: {
      type: String,
      required: true
    },
    //eslint-disable-next-line vue/require-prop-types
    value: {
      // no type, since it is different depending on context.
      required: true
    },
    upcase: {
      type: Boolean,
      default: true
    },
    showRemoveItem: {
      type: Boolean,
      default: true
    }
  },

  emits: ['remove-item'],

  methods: {
    removeItem() {
      this.$emit('remove-item', this.value)
    }
  }
}
</script>


<style lang="scss" scoped>
  .selected-value {
    display: inline-block;
  }

  .upcase {
    text-transform: uppercase;
  }

  .remove {
    background: transparent;
    border: none;
    padding: 0;
  }
</style>
